import HttpClient from "../base/http-client";

export default class SupplierClient extends HttpClient {
    constructor() {
        super("supplier", true);
    }
}
